"use client";

import Link from "next/link";

export default function AnnouncementBanner() {
  return (
    <>
      {/* Fixed banner. data-og-hide: stripped from OG-card/thumbnail screenshots
          (see scripts/generate-card-thumbnails.ts customCss). */}
      <div data-og-hide className="fixed top-0 left-0 right-0 z-[60] bg-black text-white text-center h-[40px] flex items-center justify-center px-3 sm:px-4 text-xs sm:text-sm whitespace-nowrap overflow-hidden">
        <span className="font-medium"><span className="hidden sm:inline">Our </span>No Hallucination Guarantee is <span className="hidden sm:inline">now </span>live.</span>{" "}
        <Link
          href="/blog/no-hallucination-guarantee"
          className="ml-1 underline underline-offset-2 text-white/80 hover:text-white transition-colors"
        >
          Learn more<span className="sr-only"> about the No Hallucination Guarantee</span>
        </Link>
      </div>
      {/* Spacer to offset fixed banner height */}
      <div data-og-hide className="h-[40px]" />
    </>
  );
}
